import { Text } from "@mantine/core";
import { Fragment } from "react";

import { StyledTd } from "../../../../../../styled";

interface Props {
  logStatus: string | undefined;
  eventStatus: string | undefined;
  red?: boolean;
}

const MedicalStatusCells = ({ logStatus, eventStatus, red }: Props) => {
  const eventStatusColor =
    eventStatus === "ACTIVE"
      ? "red"
      : eventStatus === "MONITORING"
        ? "orange"
        : "green";
  return (
    <Fragment>
      <StyledTd red={red}>
        <Text align="center">{logStatus ?? ""}</Text>
      </StyledTd>
      <StyledTd red={red}>
        <Text size="md" align="center" color={eventStatusColor}>
          {eventStatus ?? ""}
        </Text>
      </StyledTd>
    </Fragment>
  );
};
export default MedicalStatusCells;
